import { gridMap } from '../mapgrid.ts';
import { withGeometry } from '../mapgeo.ts';
import { SUBPEN_GEO, SUBPEN_KIT } from './subpengeo.ts';

/**
 * Sub Pen: two submarines moored in flooded slips, a torpedo room and the dock yards between. Q hull cradle block, Y conning tower,
 * B bulkhead, Z torpedo rack, U water. The boats are cigar polygons; the machine shop, crew quarters and torpedo store are roofed rooms
 * with hatches and a blast door (subpengeo.ts).
 */
const SUBPEN_GRID = gridMap('Sub Pen', `
  ............................................................
  ............................................................
  ..................................g.....BBBB................
  ...FFFFF............c...BBBBB...........BBBB................
  ...FFFFF................BBBBB................p..............
  ...FFFFF................BBBBB...............................
  ...FFFFF....ZZZZZZ......BBBBB...............................
  ...FFFFF....ZZZZZZ......BBBBB...............................
  ...FFFFF................BBBBB.................BBBBBBBBBB....
  ................................c.............BBBBBBBBBB....
  ..............................................BB............
  ..............................................BB............
  ..............l......BB.......................BB............
  ........o............BB.......................BB............
  ..................b..BB.............UUUUUU....BB............
  ...................b.BB.............UUUUUU........a.........
  .....................BB.....c.......UUUUUU..................
  .....................BB.............UUUUUU..................
  ....................................UUUUUU..............FFF.
  ....................................UUUUUU..............FFF.
  ..........BBBB..........................................FFF.
  ..........BBBB..............................................
  ..........BBBB..............................................
  ..........BBBB..............................................
  ..........BBBB..............ZZZZZZ..................c.......
  ..........BBBB..............ZZZZZZ..........................
  ............................................................
  ............................................................
  ............................................................
  ............................................................
  ............................................................
  ...BBBBBBBBBBBBB...BBBBBBBBBBBBBBBBBB...BBBBBBBBBBBBB.......
  ...BBBBBBBBBBBBB...BBBBBBBBBBBBBBBBBB...BBBBBBBBBBBBB.......
  ...UUUUUUU..................BB................UUUUUUU.......
  ...UUUUUUU..c...........b...BB..............l.UUUUUUU.......
  ...UUUUUUU.....QQ.....................QQ......UUUUUUU.......
  ...UUUUUUU.l...QQ................b....QQ......UUUUUUU.......
  ...UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU.......
  ...UUUUUUUUUUUUUUUUUUUUUYYYYYYYUUUUUUUUUUUUUUUUUUUUUU.......
  ...UUUUUUUUUUUUUUUUUUUUUYYYYYYYUUUUUUUUUUUUUUUUUUUUUU.......
  ...UUUUUUUUUUUUUUUUUUUUUYYYYYYYUUUUUUUUUUUUUUUUUUUUUU.......
  ...UUUUUUUUUUUUUUUUUUUUUYYYYYYYUUUUUUUUUUUUUUUUUUUUUU.......
  ...UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU.......
  ...UUUUUUU.....QQ.....................QQ......UUUUUUU.......
  ...UUUUUUU..e..QQ.............o.......QQ......UUUUUUU.......
  ...UUUUUUU..........BB............c...........UUUUUUU.......
  ...UUUUUUU..........BB........................UUUUUUU.......
  ...BBBBBBBBBBBBBBBBBBB...BBBBBBBBBBBBBBBB...BBBBBBBBB.......
  ...BBBBBBBBBBBBBBBBBBB...BBBBBBBBBBBBBBBB...BBBBBBBBB.......
  ............................................................
  ..........................................UUUUUU............
  ..........................................UUUUUU............
  ........................c.................UUUUUUBB..........
  ...BBBBBB...BBBBBBB.......................UUUUUUBB..........
  ...BBBBBB...BBBBBBB.......................UUUUUU........c...
  ...BB............BB.......................UUUUUU............
  ...BB.....c......BB.......................UUUUUU............
  ...BB............BB.........................................
  ...BB..ZZZZZZZZ..BB.................................a.......
  ...BB..ZZZZZZZZ..BB.............................i...........
  ...BB.....................A.........l.......................
  ...BB...b...................................................
  ...BB.........m.............................................
  ...BB............BB.........................................
  ...BB..ZZZZZZZZ..BB.....................o...................
  ...BB..ZZZZZZZZ..BB.........................................
  ...BB............BB...........b...................ZZZZZZ.c..
  ...BB.......c....BB............b..................ZZZZZZ....
  ...BB............BB.........................................
  ...BBB...BBBBBBBBBB.........................................
  ...BBB...BBBBBBBBBB...p.....................................
  ............................................................
  ............................................................
  ............................................................
  ............................................UUUUUU..........
  ............................................UUUUUU..........
  ..............................BBBBBB........UUUUUU..........
  ..............................BBBBBB........UUUUUU..........
  ..............................BBBBBB........UUUUUU..........
  ..............................BBBBBB........UUUUUU..........
  ....................BB........BBBBBB....e...................
  ....................BB........BBBBBB........................
  ....................BB............................ZZZZZZ....
  ....................BB............................ZZZZZZ....
  ....................BB....g.................................
  ....................BB......................................
  ..............BB............................................
  ..............BB............................................
  ..............BB............................................
  ..............BB............................................
  ....XXXXXX....BB.........c........................l.........
  ....XXXXXX....BB............................................
  ....XXXXXX....BB........................UUUUUU..........c...
  ....XXXXXX..............................UUUUUU..............
  ....XXXXXX....................b.........UUUUUU..............
  ....XXXXXX.....................b........UUUUUU..............
  ....XXXXXX........ZZZZZZ................UUUUUU..............
  ....XXXXXX........ZZZZZZ................UUUUUU..............
  ....XXXXXX.c................................................
  ....XXXXXX.....l............................................
  ....XXXXXX..................BBBBBB..c.................BB....
  ....XXXXXX..................BBBBBB....................BB....
  ....XXXXXX....BB............BBBBBB....................BB....
  ....XXXXXX....BB............BBBBBB.............a......BB....
  ....XXXXXX....BB............BBBBBB....................BB....
  ..............BB............BBBBBB....................BB....
  ..............BB......o.....................................
  ..............BB............................................
  ...FFFFF......BB......................BBBBBBBBBB............
  ...FFFFF..............................BBBBBBBBBB............
  ...FFFFF....................................................
  ...FFFFF....................................................
  ...FFFFF........c...................................m.......
  ...FFFFF....................................................
  ............................................................
  ........................c....................bb.............
  ............................................................
  ........o...................................................
  ............................................................
  ............................................................
`, 'subpen');

export const SUBPEN = withGeometry(withGeometry(SUBPEN_GRID, SUBPEN_GEO), SUBPEN_KIT);
